<template>
  <div class="footer">
    <!--  -->
    <div class="clear" :class="['mainBody', 'f-cont']">
      <div class="fl fleft">
        <div class="fline colorfff fontsize16">
          <template v-for="(item, index) in navlist">
            <router-link :to="item.url" :key="index">
              {{ item.text }}
            </router-link>
          </template>
        </div>
        <div class="fphone ftext">
          <i></i>
          <span>
            电 话：0774-2063261（纪检），0774-2063353 3811505
            2063293（营销部），3811522（办公室）</span
          >
        </div>
        <div class="fadress ftext">
          <i></i>
          <span> 地　　址：广西梧州市万秀区梧松路1号（扶典）</span>
        </div>
      </div>
      <div class="fright fr clear">
        <div class="qrCode fontsize16">
          <div class="qrInfo">
            <span>扫码关注</span>
            <span>梧州黄埔化工公众号</span>
          </div>
          <img src="../../assets/images/common/qrcode.png" />
        </div>
      </div>
    </div>
    <div class="fbeian fontsize14">
      <a
        class="fbeian_link"
        target="_blank"
        href="http://www.beian.gov.cn/portal/index.do"
      >
        Copyright 2025 All rights reserved. 桂ICP备11001114号
      </a>
      <img
        style="display: block;width: 20px;height: 20px;object-fit: contain; padding: 0 0.1vw 0 1.04vw;"
        src="../../assets/images/beian.png"
        alt=""
      />
      <a
        class="fbeian_link"
        href="https://beian.mps.gov.cn/#/query/websearch?code=45040302000302"
        rel="noreferrer"
        target="_blank"
        >桂公网安备45040302000302号</a
      >
      <div class="fbeian_com">技术支持：广州化工交易中心有限公司</div>
    </div>
  </div>
</template>
<script>
import { Tooltip } from 'element-ui'
export default {
  data() {
    return {
      navlist: [
        {
          url: '/',
          text: '首页',
          key: 'index',
          tips: '',
        },
        {
          url: '/company',
          text: '关于我们',
          key: 'company',
          tips: '',
        },
        {
          url: '/product',
          text: '产品中心',
          key: 'product',
          tips: '',
        },
        {
          url: '/news',
          text: '新闻动态',
          key: 'news',
          tips: '',
        },
        {
          url: '/recruit',
          text: '人才招聘',
          key: 'recruit',
          tips: '',
        },
        {
          url: '/contactus',
          text: '联系我们',
          key: 'contactus',
          tips: '',
        },
      ],
    }
  },
  computed: {
    currentNav: {
      get() {
        return this.$store.state.currentNav
      },
      set(val) {
        return this.$store.commit('updateCurrentNav', val)
      },
    },
  },
  components: {
    Tooltip,
  },
}
</script>
<style scoped lang="scss">
.footer {
  width: 100%;
  background: #333;
  padding: 2.6vw 0 1.04vw;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  .f-cont {
    position: relative;
    .fleft {
      // width: 28.13vw;
      min-height: 8.33vw;
      .ftext {
        height: 1.56vw;
        padding: 0 0 1.04vw 0;
        text-align: left;
        position: relative;
        &.fphone i {
          background: url('../../assets/images/common/phone.png') no-repeat;
          background-size: contain;
        }
        &.fadress i {
          background: url('../../assets/images/common/adress.png') no-repeat;
          background-size: contain;
        }
        i {
          display: inline-block;
          width: 1.56vw;
          height: 1.56vw;
          margin-right: 0.52vw;
          vertical-align: top;
          position: absolute;
          top: 0;
          left: 0;
        }
        span {
          display: inline-block;
          height: 1.56vw;
          line-height: 1.56vw;
          color: #ffffff;
          font-size: 0.94vw;
          padding-left: 2.6vw;
        }
      }

      .fline {
        padding: 0 0 2.08vw 0;
        a {
          display: inline-block;
          padding: 0 2.08vw 0 0.42vw;
          border-left: 0.21vw solid #83bb26;
          &:last-child {
            border-right: none;
          }
        }
      }
    }
    .fright {
      // width: 14.58vw;
      position: absolute;
      top: 0;
      right: 0;
      .qrCode {
        float: left;
        width: 18.23vw;
        margin: 0 1.04vw;
        .qrInfo {
          float: left;
          padding: 3.13vw 0 0 0;
          width: 9.9vw;
          span {
            display: block;
            font-size: 0.94vw;
            line-height: 1.25vw;
            padding: 0 0 1.04vw 0;
            color: #ffffff;
          }
        }

        img {
          float: left;
          // width: 100%;
          display: block;
          width: 8.33vw;
        }
      }
    }
  }
  .fbeian {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1.04vw;
    position: relative;
    width: 100%;
    text-align: center;
    .fbeian_link {
      display: inline-block;
      color: #fff;
    }
    .fbeian_com {
      display: inline-block;
      color: #fff;
      padding: 0 0 0 1.04vw;
    }
  }
}
@media (min-width: 1920px) {
  .footer {
    width: 100%;
    background: #333;
    padding: 50px 0 20px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    .f-cont {
      position: relative;
      .fleft {
        // width: 540px;
        min-height: 160px;
        .ftext {
          height: 30px;
          padding: 0 0 20px 0;
          text-align: left;
          position: relative;
          &.fphone i {
            background: url('../../assets/images/common/phone.png') no-repeat;
            background-size: contain;
          }
          &.fadress i {
            background: url('../../assets/images/common/adress.png') no-repeat;
            background-size: contain;
          }
          i {
            display: inline-block;
            width: 30px;
            height: 30px;
            margin-right: 10px;
            vertical-align: top;
            position: absolute;
            top: 0;
            left: 0;
          }
          span {
            display: inline-block;
            height: 30px;
            line-height: 30px;
            color: #ffffff;
            font-size: 18px;
            padding-left: 50px;
          }
        }

        .fline {
          padding: 0 0 40px 0;
          a {
            display: inline-block;
            padding: 0 40px 0 8px;
            border-left: 4px solid #83bb26;
            &:last-child {
              border-right: none;
            }
          }
        }
      }
      .fright {
        // width: 280px;
        position: absolute;
        top: 0;
        right: 0;
        .qrCode {
          float: left;
          width: 350px;
          margin: 0 20px;
          .qrInfo {
            float: left;
            padding: 60px 0 0 0;
            width: 190px;
            span {
              display: block;
              font-size: 18px;
              line-height: 24px;
              padding: 0 0 20px 0;
              color: #ffffff;
            }
          }

          img {
            float: left;
            // width: 100%;
            display: block;
            width: 160px;
          }
        }
      }
    }
    .fbeian {
      margin-top: 20px;
      position: relative;
      width: 100%;
      text-align: center;
      .fbeian_link {
        display: inline-block;
        color: #fff;
      }
      .fbeian_com {
        display: inline-block;
        color: #fff;
        padding: 0 0 0 20px;
      }
    }
  }
}
</style>
